import { NINE_BOX } from 'modules/reports/lib/Constants'
import type ReportForm from 'modules/reports/lib/ReportForm'
import Report from 'modules/reports/store/models/Report'

const getDefaultProjections = (reportForm: ReportForm) => {
  const chartType = reportForm.get('chart_type').value

  switch (chartType) {
    case Report.CHART_TYPES.scatterplot:
      return scatterplotDefaultProjections

    default:
      return []
  }
}

const scatterplotDefaultProjections = [
  {
    id: null,
    path: NINE_BOX.employee_name_path,
    function: null,
    group: null,
    order: null,
  },
]

export default getDefaultProjections
